import { useState } from "react";

import {
  makePostApiCall,
  makePutApiCall,
} from "../../../../shared/makeApiCall";
import { useToast } from "../../../../contexts/ToastContext";

import ModelErrorComponent from "../../../../components/modals/ModelErrorComponent";

export function UserDetailsViewModel(logout, userId) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({ type: {} });


  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getUser = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`users/${userId}`, payload);
    if (callResult.success) {
      setUser(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setLoading(false);
  };

  const createUser = async function (values) {
    let callResult = await makePostApiCall(`createUser`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
      window.location = "/users/" + callResult.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateUser = async function (values) {
    let callResult = await makePutApiCall(`users/${userId}`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const changeUserPasswordAdmin = async function (targetUserId, payload) {
    // targetUserId: id of the user whose password will be changed
    // payload expected: { password, password_confirmation }

    setLoading(true);
    let callResult = await makePostApiCall(
      `/users/reset-password/${targetUserId}`,
      payload
    );
    setLoading(false);
    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };


  return {
    createUser,
    updateUser,
    changeUserPasswordAdmin,
    getUser,
    user,
    loading,
    emptyModal,
  };
}
